import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getAvailability, saveAvailability, perr } from "../lib/api";

const SLOTS = ["06:00", "07:30", "09:00", "10:30", "16:00", "17:30", "19:00"];

export default function PriestAvailability() {
  const [avail, setAvail] = useState({});
  const today = new Date();
  const [sel, setSel] = useState(today.toISOString().slice(0, 10));
  const [chosen, setChosen] = useState([]);

  useEffect(() => { getAvailability().then((d) => setAvail(d.availability || {})).catch(() => {}); }, []);
  useEffect(() => { setChosen(avail[sel] || []); }, [sel, avail]);

  // month grid for current month
  const y = today.getFullYear(), m = today.getMonth();
  const first = new Date(y, m, 1).getDay();
  const days = new Date(y, m + 1, 0).getDate();
  const cells = [...Array(first).fill(null), ...Array.from({ length: days }, (_, i) => i + 1)];

  const toggle = (s) => setChosen((c) => (c.includes(s) ? c.filter((x) => x !== s) : [...c, s]));
  const save = async () => {
    try { await saveAvailability(sel, chosen); setAvail((a) => ({ ...a, [sel]: chosen })); toast.success("Availability saved"); }
    catch (e) { toast.error(perr(e)); }
  };
  const dstr = (d) => new Date(y, m, d).toISOString().slice(0, 10);

  return (
    <div data-testid="priest-availability" className="space-y-5">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-[#C6603A]">Ceremony schedule</p>
        <h1 className="mt-1 font-heading text-3xl font-bold">Availability</h1>
        <p className="mt-1 text-sm text-[#7A6E64]">Choose the dates and time windows where customers can book you.</p>
      </div>
      <div className="rounded-2xl border border-[#Eee3d6] bg-white p-5">
        <div className="grid grid-cols-7 gap-1 text-center text-[11px] font-semibold text-[#8A8072]">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d}>{d}</div>)}
        </div>
        <div className="mt-1 grid grid-cols-7 gap-1">
          {cells.map((c, i) => c === null ? <div key={i} /> : (
            <button key={i} onClick={() => setSel(dstr(c))} data-testid={`avail-day-${c}`}
              className={`aspect-square rounded-lg text-sm font-medium ${sel === dstr(c) ? "bg-[#8B1A2B] text-white" : avail[dstr(c)]?.length ? "bg-[#F4E4E6] text-[#8B1A2B]" : "text-[#4A4038] hover:bg-[#F5F1E8]"}`}>
              {c}
            </button>
          ))}
        </div>
      </div>
      <div className="rounded-2xl border border-[#Eee3d6] bg-white p-5">
        <p className="text-sm font-semibold">{new Date(sel + "T00:00:00").toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "short" })}</p>
        <p className="text-xs text-[#8A8072]">{chosen.length} bookable time slots</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {SLOTS.map((s) => (
            <button key={s} onClick={() => toggle(s)} data-testid={`avail-slot-${s}`}
              className={`rounded-full border px-4 py-2 text-sm font-medium ${chosen.includes(s) ? "border-[#8B1A2B] bg-[#8B1A2B] text-white" : "border-[#E7DECF] text-[#4A4038]"}`}>{s}</button>
          ))}
        </div>
        <button data-testid="avail-save" onClick={save} className="mt-4 w-full rounded-xl bg-[#8B1A2B] py-3 text-sm font-semibold text-white hover:bg-[#6F1420]">Save availability</button>
      </div>
    </div>
  );
}
